
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#FFC63C"}}),_c('g',{attrs:{"clip-path":"url(#tw-projects-tip-article-icon-clip0_3814_5446)"}},[_c('path',{attrs:{"d":"M17 29c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1h-6v1zm3-19c-3.86 0-7 3.14-7 7 0 2.38 1.19 4.47 3 5.74V25c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 11.7V24h-4v-2.3c-1.52-1.07-3-2.17-3-4.7 0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.49-1.51 3.65-3 4.7z","fill":"#0B0E1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"tw-projects-tip-article-icon-clip0_3814_5446"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(8 8)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    